export default __webpack_public_path__ + "static/img/vogue_scene_animated_0187.d7f52be.webp";